import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import gradient from "../../Assets/gradient-hero-light.png";
import { Link } from "react-router";
import ContactBlock from "../ContactBlock";
import ServicesCard from "../../components/ServicesCard"
import Image from 'react-bootstrap/Image';
import { FaCheckCircle } from "react-icons/fa";

import TechnologiesCard from "./TechnologiesCard"

export default function Service() {
    return (
        <div>
            <section className='bg-theme section-hero'>
                <Container fluid className="header-section">
                    <Row>
                        <Col md={12} >
                            <div className="padding-section-large text-center d-flex flex-column">
                                <div className="max-width-large mx-auto">
                                    <h1 className="heading-style-h1 text-white">Building Off Shore Teams</h1>
                                </div>
                                <div className='pt-2 max-width-large mx-auto'>
                                    <p className="text-size-medium">At <strong>Parabola IT Development,</strong> we specialize in helping organizations build and scale dedicated offshore teams tailored to their product and delivery goals. Since our inception in <strong>2009 with a core team of just 4 engineers</strong>, we’ve grown into a 100+ strong, multidisciplinary team serving clients across industries and geographies.</p>
                                </div>
                                <div className="pt-3 d-flex justify-content-center">
                                    <Link to="/contact" className="btn btn-dark rounded-pill px-5 py-3">Get In Touch</Link>
                                </div>
                            </div>
                        </Col>
                        <div className="pills-wrap">
                            <div className="hero-pill-left-wrap animation_slide-up-delay-2">
                                <Image src={gradient} />
                            </div>
                            <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                                <Image src={gradient} />
                            </div>
                        </div>
                    </Row>
                </Container >
            </section >
            <TechnologiesCard />
            <ServicesCard />
            <ContactBlock />
        </div >
    )
}
